import React from 'react';
import { MapPinIcon } from 'lucide-react';
interface LocationStepProps {
  location: string;
  onLocationChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectLocation: (city: string) => void;
  onNextStep: () => void;
  onPrevStep: () => void;
}
export const LocationStep = ({
  location,
  onLocationChange,
  onSelectLocation,
  onNextStep,
  onPrevStep
}: LocationStepProps) => {
  const popularCities = ['Los Angeles', 'New York', 'Chicago', 'Miami', 'San Francisco'];
  return <div data-id="element-471">
      <h1 className="text-3xl font-bold mb-4" data-id="element-472">Set Your Location</h1>
      <p className="text-xl mb-6" data-id="element-473">
        Tell us where you're located so we can find events near you.
      </p>
      <div className="mb-8" data-id="element-474">
        <div className="relative mb-6" data-id="element-475">
          <MapPinIcon className="absolute left-3 top-3 text-gray-400" size={24} data-id="element-476" />
          <input type="text" placeholder="Enter your city" value={location} onChange={onLocationChange} className="w-full p-3 pl-12 border border-gray-300 rounded-lg text-lg" data-id="element-477" />
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-478">
          <h3 className="font-medium mb-2" data-id="element-479">Popular locations</h3>
          <div className="flex flex-wrap gap-2" data-id="element-480">
            {popularCities.map(city => <button key={city} onClick={() => onSelectLocation(city)} className="bg-white border border-gray-300 rounded-full px-4 py-2 text-sm hover:bg-gray-100" data-id="element-481">
                {city}
              </button>)}
          </div>
        </div>
      </div>
      <div className="flex justify-between mt-8" data-id="element-482">
        <button onClick={onPrevStep} className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-483">
          Back
        </button>
        <button onClick={onNextStep} className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors" disabled={!location} data-id="element-484">
          Continue
        </button>
      </div>
    </div>;
};